.container {
    display: flex;
    flex-direction: column;
}

.messagesContainer {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.inputArea {
    padding: 16px;
    display: flex;
    flex-direction: row;
    gap: 12px;
    background-color: var(--hps-white);
    align-items: flex-end;
}

.textAreaWrapper {
    flex: 1;
}
